import { render } from "./TemplateIsoSelection.vue?vue&type=template&id=7478c00f&scoped=true"
import script from "./TemplateIsoSelection.vue?vue&type=script&lang=js"
export * from "./TemplateIsoSelection.vue?vue&type=script&lang=js"

import "./TemplateIsoSelection.vue?vue&type=style&index=0&id=7478c00f&lang=less&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7478c00f"]])

export default __exports__